import { Controller } from "@hotwired/stimulus"
import Datepicker from "../src/datepicker/Datepicker"
import { panelShiftIntoView } from "../src/calendar/popover_position"

// Rozwijany wybór daty przy przycisku "Dziś" w widokach kalendarza.
// Panel z kalendarzem (Datepicker w trybie inline) budujemy dopiero przy pierwszym
// otwarciu, a po wybraniu dnia przechodzimy pod ten sam adres z podmienionym
// parametrem daty (day albo week) - dzięki temu jeden kontroler obsługuje widok
// dzienny i tygodniowy, zarówno w module Calendar, jak i w kalendarzu zadań.
export default class extends Controller {
  static targets = ["panel", "picker"]
  static values = {
    url: String,
    param: String,
    selected: String,
    locale: { type: String, default: "pl" }
  }

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.close()
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  toggle(event) {
    event.preventDefault()
    if (this.panelTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.buildPicker()
    this.fitPanel()
    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  // panel wisi na prawej krawędzi przycisku - na wąskim ekranie trzeba go dosunąć,
  // inaczej kalendarz wychodzi poza lewą krawędź okna i części dni nie da się kliknąć
  fitPanel() {
    this.panelTarget.style.transform = ""
    const shift = panelShiftIntoView(this.panelTarget.getBoundingClientRect(), window.innerWidth)
    if (shift !== 0) this.panelTarget.style.transform = `translateX(${shift}px)`
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  // Datepicker w trybie inline sam się rysuje w podanym elemencie, więc tworzymy go
  // raz - przy pierwszym otwarciu panelu, żeby nie budować kalendarza na każdej stronie
  buildPicker() {
    if (this.picker) return

    const locale = Datepicker.locales[this.localeValue] ? this.localeValue : "en"
    this.pickerTarget.dataset.date = this.selectedValue || ""
    this.picker = new Datepicker(this.pickerTarget, {
      language: locale,
      weekstart: 1,
      todayHighlight: true,
      format: "yyyy-mm-dd"
    })
    this.pickerTarget.addEventListener("changeDate", () => this.goToSelectedDate())
  }

  goToSelectedDate() {
    const date = this.picker.getDate("yyyy-mm-dd")
    if (!date) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, date)
    this.close()

    if (window.Turbo) {
      window.Turbo.visit(url.toString())
    } else {
      window.location.assign(url.toString())
    }
  }
}
